import * as React from 'react';
import { useMemo } from 'react';
import { IWidgetType } from '../widgets/IWidgetType';
import { Widget } from '../widgets/Widget';
import { WidgetDirectivesRepository } from './WidgetDirectivesRepository';

export interface IWidgetDirectivesInputProps {
  widget: Widget;
  widgetType: IWidgetType<Widget>;
}

export function WidgetDirectivesInput(props: IWidgetDirectivesInputProps) {
  const { widget, widgetType } = props;

  const supportedDirectives = useMemo(() => {
    if (widgetType.configOptions?.hideDirectives) return [];
    return WidgetDirectivesRepository.getAll().filter(directive =>
      directive.allowsWidget(widget, widgetType),
    );
  }, [widget, widgetType]);

  // TODO Al momento utilizziamo la configurazione per l'intero _widget_, ma
  // in realtà dovremmo farla per ogni _reference_.
  return (
    <div>
      {supportedDirectives.map(directive => {
        if (directive.configComponent == undefined) return null;
        return (
          <div key={directive.key}>
            <directive.configComponent
              name={`directives.${directive.key}`}
              widget={widget}
              widgetType={widgetType}
            />
          </div>
        );
      })}
    </div>
  );
}
